var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2158_17341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16199 4.95578L1.90865 5.57245L1.83332 5.58778C1.71928 5.61806 1.61532 5.67805 1.53205 5.76165C1.44878 5.84524 1.38919 5.94944 1.35936 6.0636C1.32953 6.17776 1.33054 6.29779 1.36227 6.41143C1.394 6.52507 1.45533 6.62826 1.53999 6.71045L4.62132 9.70978L3.89465 13.9464L3.88599 14.0198C3.87901 14.1377 3.9035 14.2554 3.95695 14.3608C4.01041 14.4662 4.09091 14.5554 4.19021 14.6195C4.28951 14.6835 4.40405 14.72 4.52209 14.7252C4.64013 14.7304 4.75743 14.7041 4.86199 14.6491L8.66599 12.6491L12.4613 14.6491L12.528 14.6798C12.638 14.7231 12.7576 14.7364 12.8745 14.7183C12.9914 14.7002 13.1013 14.6513 13.193 14.5766C13.2848 14.502 13.355 14.4043 13.3965 14.2935C13.4381 14.1828 13.4494 14.063 13.4293 13.9464L12.702 9.70978L15.7847 6.70978L15.8367 6.65312C15.9109 6.56163 15.9596 6.45208 15.9778 6.33565C15.996 6.21921 15.9829 6.10003 15.94 5.99027C15.8972 5.8805 15.8259 5.78407 15.7336 5.71079C15.6414 5.63751 15.5313 5.59001 15.4147 5.57312L11.1613 4.95578L9.25999 1.10245C9.20497 0.990805 9.1198 0.896792 9.01411 0.831051C8.90843 0.765311 8.78645 0.730469 8.66199 0.730469C8.53752 0.730469 8.41555 0.765311 8.30986 0.831051C8.20418 0.896792 8.119 0.990805 8.06399 1.10245L6.16199 4.95578Z",
    fill: "#FBBC05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2158_17341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.666626 0.0625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.540a6a6fdee961533ad96f90e7e70856.svg";
export { ForwardRef as ReactComponent };